<div class="container">
    <div class="alert alert-success text-center">
        <h1 class="alert-heading">runADAPT</h1>
        <p>Stakeholder management for {{ ProjectLabel }}</p>
    </div>
</div>
